import { injectable, inject } from 'inversify';
import { ObjectCompletionHandlerInterface } from './object-completion-handler-interface';
import { SectionInteraction, SectionCompletion } from '@/app/statistics/section/section-progress';
import { SectionProgressUtils, SectionProgressUtilsSymbol } from '@/app/statistics/section/section-progress-utils';
import { createInteractionId } from '../section/section-interaction-utils';

export const HOTSPOT_TYPE: string = 'hotspot';

@injectable()
export class HotspotItemsCompletionHandler implements ObjectCompletionHandlerInterface {

  @inject(SectionProgressUtilsSymbol)
  private sectionProgressUtils: SectionProgressUtils;

  public calculateDefaultInteractions($container: any|null): SectionInteraction[] {
    let interactions: SectionInteraction[] = [];
    $('.hotspot-component', $container).each((index: number, element: any) => {
      const $element: any = $(element);
      const id: string = createInteractionId(HOTSPOT_TYPE, $element.attr('id'));
      const title: string = $element.attr('data-title') || 'hotspot-component';

      const items: { [id: string]: boolean } = {};
      $('.item-wrapper', $element).each((itemIndex: number) => {
        const itemId: string = this.sectionProgressUtils.createItemId(id, itemIndex);
        items[itemId] = false;
      });

      interactions = [...interactions, {
        id,
        title,
        type: HOTSPOT_TYPE,
        completed: false,
        items
      }];
    });

    return interactions;
  }

  public setInteraction(completion: SectionCompletion, interaction: any): SectionCompletion {
    if (interaction.type && interaction.type === HOTSPOT_TYPE) {
      const hotspotId: string = interaction.id;
      const itemId: string = this.sectionProgressUtils.createItemId(hotspotId, interaction.index);
      completion = this.sectionProgressUtils.setInteractionItemCompleted(completion, hotspotId, HOTSPOT_TYPE, itemId);
    }

    return completion;
  }
}
